import {LocalOverrideAdapter} from '@statsig/js-local-overrides';

export const overrideAdapter = new LocalOverrideAdapter();
